// extracted by mini-css-extract-plugin
module.exports = {"input_link":"LinkModal_input_link__OgnBL","button_div":"LinkModal_button_div__1T5p9"};